var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10C16.6667 9.08333 17.4167 8.33333 18.3334 8.33333V5C18.3334 4.08333 17.5834 3.33333 16.6667 3.33333H3.33335C2.41669 3.33333 1.67502 4.08333 1.67502 5V8.33333C2.59169 8.33333 3.33335 9.08333 3.33335 10C3.33335 10.9167 2.59169 11.6667 1.66669 11.6667V15C1.66669 15.9167 2.41669 16.6667 3.33335 16.6667H16.6667C17.5834 16.6667 18.3334 15.9167 18.3334 15V11.6667C17.4167 11.6667 16.6667 10.9167 16.6667 10ZM12.9834 14L10 12.0833L7.01669 14L7.91669 10.5667L5.17502 8.325L8.70835 8.11667L10 4.83333L11.2834 8.125L14.8167 8.33333L12.075 10.575L12.9834 14V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalActivity);
export default __webpack_public_path__ + "static/media/local-activity.c9e433d6ec216396c4dc579da29cceab.svg";
export { ForwardRef as ReactComponent };